module.exports = __webpack_public_path__ + "static/media/logo.feed2893.png";